<template>
  <header class="naruto-header">
    <div class="naruto-header__content">
      <h1
        class="naruto-header__title decoration-logo"
        :alt="$store.state.config.title"
      />

      <p class="naruto-header__text">
        {{ $store.state.config.subtitle }}
      </p>

      <ButtonVideo
        class="naruto-header__cta"
        @click.native="$emit('clickVideo')"
      />
    </div>

    <div class="naruto-header__background naruto-header__background--mobile decoration-header" />
    <div class="naruto-header__background naruto-header__background--medium decoration-header-small" />
    <div class="naruto-header__background naruto-header__background--large decoration-header-large" />
  </header>
</template>

<script>
import ButtonVideo from '@/components/buttons/buttonVideo.vue';

export default {
  name: 'PageHeader',

  components: {
    ButtonVideo,
  },
};
</script>

<style lang="stylus" scoped>
.naruto-header {
  position: relative;
  padding: 0 0 45px 0;
  +desktop() { padding-bottom: 0; }
}

.naruto-header__background {
  width: 100%;
  height: 0;
  padding-bottom: (344 / 360 * 100%);

  background-size: contain;

  &--medium {
    display: none;
    padding-bottom: (676 / 1439 * 100%);
  }

  &--large {
    display: none;
    padding-bottom: (752 / 1920 * 100%);
  }

  +desktop() {
    &--mobile { display: none; }
    &--medium { display: block; }
  }

  +above(xl) {
    &--medium { display: none; }
    &--large { display: block; }
  }
}

.naruto-header__content {
  max-width: 304px;
  margin: 20px auto 0 auto;

  text-align: center;

  +desktop() {
    position: absolute;

    margin: 10px 0 0 60px;

    text-align: left;
  }

  +above(xl) { margin-left: 120px; }
}

.naruto-header__title { display: inline-block; }

.naruto-header__text {
  @extends $txt-default;

  margin: 20px 0 0 0;

  +desktop() { margin: 30px 0 10px 0; }
}

.naruto-header__cta {
  position: absolute;
  bottom: 0;
  right: 10px;

  width: (150 / 360) * 100%;
  max-width: 235px;

  +desktop() {
    position: static;

    width: 100%;
  }
}
</style>
